import React from "react";
import { useParams } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import SystemBugList from "./SystemBugList";
import SystemBugDetail from "./SystemBugDetail";
import SystemBugEmptyState from "./SystemBugEmptyState";
import { useGetListOfBugsQuery } from "@/features/bughurd/api";

interface SystemBugProps {
  parentData?: any;
}

const SystemBug: React.FC<SystemBugProps> = ({ parentData }) => {
  const { bugId, id: projectId } = useParams<{ bugId?: string; id: string }>();

  // Fetch bug list to check if there's any data
  const { data: systemBugsData, isLoading } = useGetListOfBugsQuery(
    {
      id: projectId,
      page: 0,
      limit: 1,
      bugFor: "AUTO_BUG",
      withDetails: false,
    },
    { skip: !projectId || !!bugId }, // Skip API call if bugId exists (detail view)
  );

  // If bugId is present in URL, show detail view
  if (bugId) {
    return <SystemBugDetail bugId={bugId} parentData={parentData} />;
  }

  // Show loading state while fetching data
  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "calc(100vh - 200px)",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // Extract bug items from the response
  const bugItems =
    systemBugsData?.data?.decryptedData?.items ||
    systemBugsData?.data?.items ||
    [];

  // If no bugs found, show empty state with setup instructions
  if (bugItems.length === 0) {
    return <SystemBugEmptyState />;
  }

  // Show bug list if data exists
  return <SystemBugList parentData={parentData} />;
};

export default SystemBug;
